import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { ButtonUniversal } from 'src/domains/layouts/shared/buttons/Button.style';

export type ButtonVersion = 
    'primary' |
    'secondary'

export interface PropsType {
    children: React.ReactNode;
    className?: string;
    version?: ButtonVersion;
    size?: 'small' | 'regular' | 'big';
    status?: 'ok' | 'error' | 'default' | 'delete';
    width?: 'full' | 'default';
    isDisabled?: boolean,
    onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
    dataTest?: string;
}

export const Button = observer('Button', ({
    children,
    className,
    version = 'primary',
    size = 'regular',
    width = 'default',
    status,
    isDisabled,
    onClick,
    dataTest,
}: PropsType) => {

    return (
        <ButtonUniversal
            className={className}
            data-test={dataTest}
            disabled={isDisabled}
            onClick={onClick}
            size={size}
            width={width}
            version={version}
            status={status}
        >
            {children}
        </ButtonUniversal>
    );
});
